module.exports = __webpack_public_path__ + "static/media/customer-3.807798cb.jpg";